import styled from "@xstyled/styled-components";

import { Button, Text } from "@otta/design";
import { palette } from "@otta/design-tokens";
import { ApolloIAPProvider } from "@otta/shared-components";

const Banner = styled.div`
  background: ${palette.brand.yellow};
  padding: lg;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface IAPRefresherProps {
  children: React.ReactNode;
}

export function IAPRefresher({
  children,
}: IAPRefresherProps): React.ReactElement {
  if (import.meta.env.MODE === "staging") {
    return (
      <ApolloIAPProvider uri={`${import.meta.env.VITE_API_HOST}/graphql`}>
        {renderProps => (
          <>
            {!renderProps.authenticated && (
              <Banner>
                <Text bold size={1}>
                  You&apos;re disconnected from the API!
                </Text>
                <Button
                  size="small"
                  level="secondary"
                  onClick={renderProps.onReauthenticate}
                >
                  Reauthenticate
                </Button>
              </Banner>
            )}
            {children}
          </>
        )}
      </ApolloIAPProvider>
    );
  }

  return <>{children}</>;
}
